// extracted by mini-css-extract-plugin
export var outerContainer = "index-module--outerContainer--21x5z";
export var previewContainer = "index-module--previewContainer--lP69a";
export var titleContainer = "index-module--titleContainer--ed_Tj";
export var image = "index-module--image--3K4U3";
export var titleStyle = "index-module--titleStyle--1F3tm";
export var previewHeader = "index-module--previewHeader--3cTZH";
export var previewContent = "index-module--previewContent--p5S0J";
export var previewCta = "index-module--previewCta--1-aFu";